(() => {
  const carouselSelector = '.product-set-upsell';

  function initialise(root = document) {
    root.querySelectorAll(carouselSelector).forEach((carousel) => {
      if (carousel.dataset.paginationReady === 'true') return;

      const viewport = carousel.querySelector('.product-set-upsell__viewport');
      const track = carousel.querySelector('.product-set-upsell__track');
      const cards = Array.from(carousel.querySelectorAll('[data-product-set-upsell-card]'));
      const dots = Array.from(carousel.querySelectorAll('[data-product-set-upsell-dot]'));
      if (!viewport || !track || !cards.length || cards.length !== dots.length) return;

      carousel.dataset.paginationReady = 'true';

      const slideLeft = (card) => card.offsetLeft - track.offsetLeft;
      const setActive = (index) => {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          viewport.scrollTo({
            left: slideLeft(cards[index]),
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
          setActive(index);
        });
      });

      let frame = 0;
      viewport.addEventListener(
        'scroll',
        () => {
          if (frame) return;
          frame = window.requestAnimationFrame(() => {
            frame = 0;
            let closestIndex = 0;
            let closestDistance = Number.POSITIVE_INFINITY;

            cards.forEach((card, index) => {
              const distance = Math.abs(slideLeft(card) - viewport.scrollLeft);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            setActive(closestIndex);
          });
        },
        { passive: true }
      );

      const mobile = window.matchMedia('(max-width: 749px)');
      const originalTouchAction = viewport.style.touchAction;
      const originalUserSelect = viewport.style.userSelect;
      const updateTouchMode = () => {
        viewport.style.touchAction = mobile.matches ? 'pan-y' : originalTouchAction;
        viewport.style.userSelect = mobile.matches ? 'none' : originalUserSelect;
        carousel.querySelectorAll('.product-set-upsell__media-viewport').forEach(media => { media.style.touchAction = mobile.matches ? 'pan-y' : ''; });
      };
      mobile.addEventListener('change', updateTouchMode);
      updateTouchMode();
      let pointer = null;
      let suppressClickUntil = 0;
      viewport.addEventListener('pointerdown', (event) => {
        if (!mobile.matches || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        if (event.target.closest('button, input, select, textarea')) return;
        pointer = {id: event.pointerId, x: event.clientX, y: event.clientY, horizontal: false};
      }, true);
      viewport.addEventListener('pointermove', (event) => {
        if (!pointer || pointer.id !== event.pointerId) return;
        const dx = Math.abs(event.clientX - pointer.x);
        const dy = Math.abs(event.clientY - pointer.y);
        if (!pointer.horizontal && dy > 10 && dy > dx) { pointer = null; return; }
        if (!pointer.horizontal && dx > 10 && dx > dy * 1.2) {
          pointer.horizontal = true;
          viewport.setPointerCapture(event.pointerId);
        }
        if (pointer?.horizontal) event.stopPropagation();
      }, true);
      viewport.addEventListener('pointerup', (event) => {
        if (!pointer || pointer.id !== event.pointerId) return;
        const gesture = pointer;
        pointer = null;
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
        if (!gesture.horizontal) return;
        event.stopPropagation();
        event.preventDefault();
        suppressClickUntil = Date.now() + 350;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (Math.abs(dx) < 28 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        const index = cards.reduce((best, card, current) => Math.abs(slideLeft(card) - viewport.scrollLeft) < Math.abs(slideLeft(cards[best]) - viewport.scrollLeft) ? current : best, 0);
        const next = Math.max(0, Math.min(cards.length - 1, index + (dx < 0 ? 1 : -1)));
        viewport.scrollTo({left: slideLeft(cards[next]), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        setActive(next);
      }, true);
      viewport.addEventListener('pointercancel', () => { pointer = null; });
      viewport.addEventListener('lostpointercapture', (event) => { if (event.target === viewport) pointer = null; });
      viewport.addEventListener('click', (event) => {
        if (Date.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      setActive(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

/* REEF ROSE UPSELL IMAGE PAGINATION */
(() => {
  function initialiseMediaSlider(slider) {
    if (slider.dataset.mediaPaginationReady === 'true') return;
    const viewport = slider.querySelector('.product-set-upsell__media-viewport');
    const track = slider.querySelector('.product-set-upsell__media-track');
    const slides = Array.from(slider.querySelectorAll('[data-product-set-upsell-media-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-product-set-upsell-media-dot]'));
    if (!viewport || !track || slides.length < 2 || slides.length !== dots.length) return;

    slider.dataset.mediaPaginationReady = 'true';
    const slideLeft = (slide) => slide.offsetLeft - track.offsetLeft;
    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      slides.forEach((slide, slideIndex) => {
        slide.tabIndex = slideIndex === index ? 0 : -1;
      });
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        viewport.scrollTo({
          left: slideLeft(slides[index]),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        setActive(index);
      });
    });

    let frame = 0;
    viewport.addEventListener('scroll', () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        slides.forEach((slide, index) => {
          const distance = Math.abs(slideLeft(slide) - viewport.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        setActive(closestIndex);
      });
    }, { passive: true });

    /* REEF ROSE DESKTOP UPSELL NEXT IMAGE HOVER */
    const preciseHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    let hoverActive = false;
    const showSlide = (index) => {
      viewport.scrollTo({ left: slideLeft(slides[index]), behavior: 'auto' });
      setActive(index);
    };

    slider.addEventListener('pointerenter', (event) => {
      if (!preciseHover.matches || (event.pointerType && event.pointerType !== 'mouse')) return;
      hoverActive = true;
      showSlide(1);
    });

    slider.addEventListener('pointerleave', (event) => {
      if (!hoverActive || !preciseHover.matches || (event.pointerType && event.pointerType !== 'mouse')) return;
      hoverActive = false;
      showSlide(0);
    });
    /* END REEF ROSE DESKTOP UPSELL NEXT IMAGE HOVER */

    setActive(0);
  }

  function initialise(root = document) {
    root.querySelectorAll?.('[data-product-set-upsell-media-slider]').forEach(initialiseMediaSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
/* END REEF ROSE UPSELL IMAGE PAGINATION */
